// src/i18n/ru.js

const ru = {
    // ── Header & Hero ────────────────────────────────────────────
    headerPlaceholder: 'ID транзакции / ордера',
    heroSubtitle:      'Поиск транзакции или ордера',
    authComingSoon:    'Авторизация будет доступна в ближайшее время.',

    heroTitle:         'Поиск транзакции или ордера',

    // ── OrderCard ────────────────────────────────────────────────
    amount:       'Сумма',
    sender:       'Отправитель',
    receiver:     'Получатель',
    description:  'Описание',
    feeSend:      'Комиссия оплачена получателем',
    feeGet:       'Комиссия оплачена отправителем',
    linkedOrder:  'Ордер',
    pay:          'Оплатить',

    // ── SearchOrder ──────────────────────────────────────────────
    searchTitle:       'Search Order',
    searchPlaceholder: 'Введите номер заказа',
    searchButton:      'Найти',
    searchNotFound:    'Заказ не найден или не входит в список активных.',

    // ── PayWidget ────────────────────────────────────────────────
    payTitle:    'Оплата заказа',
    payButton:   'Оплатить',
    paySuccess:  'Оплата прошла успешно',
    payError:    'Ошибка оплаты',

    // ── Общие ────────────────────────────────────────────────────
    loading: 'Загрузка...',
    error:   'Ошибка',
    close:   'Закрыть',
    noData:  '—',
};

export default ru;
